import React from "react";
import { connect } from "react-redux";
import { Router, Route, Switch } from "react-router-dom";

import history from "../history";

import Dashboard from "./Dashboard";
import ErrorScreen from "./ErrorScreen";
import Activate from "./Activate";
import ResetPass from "./ResetPass";
import AnswerRequest from "./AnswerRequest/AnswerRequest";
import Login from "./Login";

class App extends React.Component {
    showError = (Component, props) => {
        if (this.props.error.statusText) {
            return (
                <ErrorScreen {...props}
                    statusCode={this.props.error.statusCode}
                    statusText={this.props.error.statusText}
                    message={this.props.error.message}
                />
            );
        }
        else return Component;
    }

    render() {
        return (
            <Router history={history}>
                <Switch>
                    <Route path="/login" exact render={props => this.showError(<Login {...props} />, props)} />
                    <Route path="/activate/:token" exact render={props => this.showError(<Activate {...props} operation="activate" />, props)} />
                    <Route path="/reset/:token" exact render={props => this.showError(<Activate {...props} operation="reset" />, props)} />
                    <Route path="/reset" exact render={props => this.showError(<ResetPass {...props} />, props)} />
                    <Route path="/requests/answer/:token" exact render={props => this.showError(<AnswerRequest {...props} />, props)} />
                    <Route path="/" render={props => this.showError(<Dashboard {...props} />, props)} />
                </Switch>
            </Router>
        );
    }
}

const mapStateToProps = state => ({ error: state.error });

export default connect(mapStateToProps)(App);